module.exports = __webpack_public_path__ + "img/logo.579d26f5.png";